<template>
    <div class="row">
        
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <el-form ref="fee" label-position="left" label-width="100px">
                        <el-form-item label="Fee name">
                                <el-input size="mini" class="grey" v-model.number="feeData.name" @blur="changeHandler"></el-input>
                        </el-form-item>
                        <el-form-item label="Price">
                                <vue-numeric class="form-control-sm greycolors"
                                    :currency="symbol"
                                    :separator="separator"
                                    :decimal-separator="decimalSeparator"
                                    currency-symbol-position="suffix"
                                    :precision="fractionalDigits"
                                    :min="0"
                                    @blur="changeHandler"
                                    v-model="feeData.price">
                                </vue-numeric>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { mapMutations, mapActions } from 'vuex';
import VueNumeric from 'vue-numeric';

import CphButton from '../../../components/Shared/UI/Button/CphButton';

export default {
    name: 'fee',
    data() {
        return {
            feeData: {
                name: '',
                price: 0,
                type: this.feeForProduct ? 'product': 'order',
                active: false,
            },
            show: false,
            isValid: false,
            message: '',
            newFees: []
        }
    },
    props: {
        feeForProduct: {
            type: Boolean,
            default: false,
        },
        editFee: {
            type: Object,
            default: () => {}
        },
        symbol: '',
        fees: [],
        noTable: {
            default: false, 
            type: Boolean
        },
        fractionalDigits: {default: 2},
        decimalSeparator: {
            deafult: "."
        },
        separator: {
            default: ","
        }
    },
    components: {
        VueNumeric,
        CphButton
    },
    methods: {
        ...mapActions(['setFee', 'updateFee', 'deleteFee']),
        ...mapMutations(['addAlert']),
        // manageFee() {
        //     if(this.$v.feeData.$invalid) { 
        //         this.addAlert({
        //             title: 'Invalid fee data ',
        //             type: 'warning', 
        //             body: `Fill form correctly`
        //         });
        //     }
        //     // this.editFee ? this.editCurrentFee(this.feeData) : 
        //     this.setNewFee(this.feeData);
        // },
        changeHandler(e) {
            this.$emit('blur', e)
            this.$emit("addFunctionToSave", {id: `fee-set`, run: () => {
                this.$store.dispatch('setFee', {...this.feeData})
                this.$store.dispatch('getFees')
                this.$emit('showInformationUpdateCubes')
            }})
        },
        // async editCurrentFee() {
        //     await this.updateFee(this.feeData).catch(err => console.log(err));
        //     this.$emit('updateFee', this.feeData);
        // },
        deleteCurrentFee() {
            this.$emit("addFunctionToSave", {id: `fee-delete`, run: () => {
                this.$store.dispatch('deleteFee', this.feeData.id)
                this.$store.dispatch('getFees')
                this.$emit('deleteFee', this.feeData.id)
                this.$emit('showInformationUpdateCubes')
            }})
        },
        addProductFee() { 
            this.show = true;
        },
        isActive(value) {
            this.feeData.active = !this.feeData.active;
        },
        isInvalidAndTouched(inputName) {
            return this.$v.feeData[inputName].$invalid && this.$v.feeData[inputName].$dirty;
        }
    },
    validations: {
        feeData: {
            name: {
                required,
            },
            price: {
                required
            }
        }
    },
    mounted() {
        this.editFee ? this.feeData = {...this.editFee} : null;
    },
}
</script>

<style lang="scss" scoped>
    .invalid-block {
        padding: 5px 0px;
        color: #ff2323;
        font-size: 14px;
    }
    .form-group {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        label {
            float: left;
        }
        input {
            &.invalid {
                border-color: red;
            }
        }
        div, * {
            margin-right: 5px;
        }
    }
    .greycolors {
        width: 100%;
        border: 1px solid #DCDFE6;
    }
</style>

